import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { post } from '../Auths/AuthToken';
// import { setAllData } from '../../redux/slices/patient/customCounsellingOneSlice';
import Button from '../Button';

export default function AddSubCatagoryInCounsellingPopup({
  cancelSubLable,
  addSubCategoryData,
  providerId,
  setAllData,
  allData,
  type,
}) {
  const [labelName, setLabelName] = useState(
    addSubCategoryData?.labelName || ''
  );

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  // const { allData } = useSelector((store) => store.customCounsellingOne);
  const addSubLableName = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/addEditSubLableName',
        {
          id: addSubCategoryData?.id,
          tabId: addSubCategoryData?.tabId,
          catId: addSubCategoryData?.catagory,
          tabName: labelName,
          staffUserId: user?.id,
          type: type,
          providerId: providerId,
        }
      );

      if (response.status === 200) {
        if (addSubCategoryData?.id) {
          dispatch(
            setAllData({
              ...allData,
              therapyMasterData: allData?.therapyMasterData?.map((item) => {
                if (item[0] === addSubCategoryData?.tabId) {
                  return [
                    item[0],
                    item[1],
                    item[2].map((subItem) => {
                      if (subItem[0] === addSubCategoryData?.id) {
                        return [
                          response?.data?.id,
                          response?.data?.labelName,
                          subItem[2],
                        ];
                      }
                      return subItem;
                    }),
                  ];
                }
                return item;
              }),
            })
          );
        } else {
          dispatch(
            setAllData({
              ...allData,
              therapyMasterData: allData?.therapyMasterData?.map((item) => {
                if (item[0] === response?.data?.tabId) {
                  return [
                    item[0],
                    item[1],
                    [
                      ...item[2],
                      [response?.data?.id, response?.data?.labelName, []],
                    ],
                    item[3],
                    item[4],
                  ];
                }
                return item;
              }),
            })
          );
        }
        cancelSubLable();
      }
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <div className="modalBackground">
      <div id="labelUpdateBlock" className="preferd-pharmacy-edit-main-block">
        <div className="prefrd-pharmcy-edit-header">
          <span className="prefrd-pharmcy-edit-name">Sub Category Label</span>
          <Button variant="circle" onClick={cancelSubLable}>
            X
          </Button>
        </div>
        <div className="form-bg-color">
          <div className="prefrd-pharmcy-edit-body-row">
            <span className="pharmcy-edit-body-row-label">Name:</span>
            <span
              className="pharmcy-edit-body-row-value"
              style={{ width: 'calc(100% - 66px)' }}
            >
              <input
                type="text"
                name="labelName"
                id="labelName"
                value={labelName}
                onChange={(e) => setLabelName(e.target.value)}
              />
            </span>
          </div>
        </div>
        <div className="prefrd-pharmacy-add-edit-button-row">
          <Button variant="primary" onClick={addSubLableName}>
            {addSubCategoryData?.id ? 'Update' : 'Add'}
          </Button>
          <Button variant="outline" onClick={cancelSubLable}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}
